import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    FaShoppingCart,
    FaHourglassHalf,
    FaCheckCircle,
    FaTimesCircle,
    FaBoxOpen,
    FaCheck,
    FaBan,
    FaUsers,
} from "react-icons/fa";
import "../Pages/CSS/Dashboard.css";
import { backend_url } from "../App";

const Dashboard = () => {
    const [stats, setStats] = useState({
        totalOrders: 0,
        pendingOrders: 0,
        completedOrders: 0,
        cancelledOrders: 0,
        totalProducts: 0,
        availableProducts: 0,
        outOfStockProducts: 0,
        totalUsers: 0,
    });
    const [mostOrdered, setMostOrdered] = useState([]);
    const [highestRated, setHighestRated] = useState([]);

    useEffect(() => {
        fetchOrders();
        fetchProducts();
        fetchUsersCount();
        fetchExtraStats();
    }, []);

    const fetchExtraStats = async () => {
        try {
            const orderedRes = await axios.get(`${backend_url}/most-ordered-products`);
            const ratedRes = await axios.get(`${backend_url}/highest-rated-products`);
            setMostOrdered(orderedRes.data);
            setHighestRated(ratedRes.data);
        } catch (error) {
            console.error("Error fetching extra stats:", error);
        }
    };



    // Fetch Orders Data
    const fetchOrders = async () => {
        try {
            const res = await axios.get(`${backend_url}/allorders`);
            const data = res.data.orders;

            const totalOrders = data.length;
            const pendingOrders = data.filter(order => order.status === "Pending").length;
            const completedOrders = data.filter(order => order.status === "Completed").length;
            const cancelledOrders = data.filter(order => order.status === "Cancelled").length;

            setStats(prevStats => ({
                ...prevStats,
                totalOrders,
                pendingOrders,
                completedOrders,
                cancelledOrders,
            }));
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    // Fetch Products Data
    const fetchProducts = async () => {
        try {
            const res = await axios.get(`${backend_url}/allproducts`);
            const data = res.data;

            const totalProducts = data.length;
            const availableProducts = data.filter(product => product.avilable).length;
            const outOfStockProducts = totalProducts - availableProducts;

            setStats(prevStats => ({
                ...prevStats,
                totalProducts,
                availableProducts,
                outOfStockProducts,
            }));
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    // ✅ Fetch Users Count
    const fetchUsersCount = async () => {
        try {
            const res = await axios.get(`${backend_url}/getalluserscount`);
            setStats(prevStats => ({
                ...prevStats,
                totalUsers: res.data.totalUsers
            }));
        } catch (error) {
            console.error("Error fetching user count:", error);
        }
    };

    return (
        <div className="admin-dashboard">
            <h1>Admin Dashboard</h1>

            {/* Orders Stats Section */}
            <div className="stats">
                <div className="stat-card total">
                    <FaShoppingCart className="icon total-icon" />
                    <div>
                        <h3>Total Orders</h3>
                        <p>{stats.totalOrders}</p>
                    </div>
                </div>
                <div className="stat-card pending">
                    <FaHourglassHalf className="icon pending-icon" />
                    <div>
                        <h3>Pending Orders</h3>
                        <p>{stats.pendingOrders}</p>
                    </div>
                </div>
                <div className="stat-card completed">
                    <FaCheckCircle className="icon completed-icon" />
                    <div>
                        <h3>Completed Orders</h3>
                        <p>{stats.completedOrders}</p>
                    </div>
                </div>
                <div className="stat-card cancelled">
                    <FaTimesCircle className="icon cancelled-icon" />
                    <div>
                        <h3>Cancelled Orders</h3>
                        <p>{stats.cancelledOrders}</p>
                    </div>
                </div>

                {/* Product Stats Section */}

              
                <div className="stat-card available">
                    <FaCheck className="icon available-icon" />
                    <div>
                        <h3>Available Products</h3>
                        <p>{stats.availableProducts}</p>
                    </div>
                </div>
                <div className="stat-card out-of-stock">
                    <FaBan className="icon out-of-stock-icon" />
                    <div>
                        <h3>Out of Stock</h3>
                        <p>{stats.outOfStockProducts}</p>
                    </div>
                </div>

                {/* ✅ New User Count Card */}
                <div className="stat-card total-users">
                    <FaUsers className="icon user-icon" />
                    <div>
                        <h3>Total Users</h3>
                        <p>{stats.totalUsers}</p>
                    </div>
                </div>
                  <div className="stat-card total-products">
                    <FaBoxOpen className="icon product-icon" />
                    <div>
                        <h3>Overall Products</h3>
                        <p>{stats.totalProducts + 50}</p>
                    </div>
                </div>
            </div>
            {/* <div className="extra-stats">
  <div className="extra-card">
    <h3>Most Ordered Products</h3>
    <ul>
      {mostOrdered.map((product) => (
        <li key={product.productName}>
          {product.productName} - {product.totalOrders} orders
        </li>
      ))}
    </ul>
  </div>

  <div className="extra-card">
    <h3>Highest Rated Products</h3>
    <ul>
      {highestRated.map((product) => (
        <li key={product._id}>
          {product.name} - {product.quality} ⭐
        </li>
      ))}
    </ul>
  </div>
</div> */}

        </div>
    );
};

export default Dashboard;
